import React from 'react'

const About = () => {
    document.title = "About";
    return (
        <div className="container">
            <h2> Restaurant App </h2>
            <p>v.1.0</p>
        </div>
    )
};

export default About;
